// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AquariumsAndHobbyistsRouteImport } from './routes/aquariums-and-hobbyists'
import { Route as ArtemiaCystsIncubationGuideRouteImport } from './routes/artemia-cysts-incubation-guide'
import { Route as CartRouteImport } from './routes/cart'
import { Route as ContactusRouteImport } from './routes/contactus'
import { Route as DecapsulatedArtemiaGuideRouteImport } from './routes/decapsulated-artemia-guide'
import { Route as DistanceSalesAgreementRouteImport } from './routes/distance-sales-agreement'
import { Route as FaqsRouteImport } from './routes/faqs'
import { Route as GlossaryRouteImport } from './routes/glossary'
import { Route as HorecaSeafoodMiddleEastRouteImport } from './routes/horeca-seafood-middle-east'
import { Route as KvkkDisclosureTextRouteImport } from './routes/kvkk-disclosure-text'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OliveFlounderExportRouteImport } from './routes/olive-flounder-export'
import { Route as PanelRouteImport } from './routes/panel'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as RegionalTradeMiddleEastEuropeRouteImport } from './routes/regional-trade-middle-east-europe'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as RequestQuoteRouteImport } from './routes/request-quote'
import { Route as SalmonidOvaSolutionsRouteImport } from './routes/salmonid-ova-solutions'
import { Route as SeafoodExportRouteImport } from './routes/seafood-export'
import { Route as SeafoodExportFromTurkeyToEuropeRouteImport } from './routes/seafood-export-from-turkey-to-europe'
import { Route as ServicesSolutionsRouteImport } from './routes/services-solutions'
import { Route as StandRouteImport } from './routes/stand'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as AccountAddressesRouteImport } from './routes/account.addresses'
import { Route as AccountCustomsRouteImport } from './routes/account.customs'
import { Route as AccountOrdersRouteImport } from './routes/account.orders'
import { Route as AccountProfileRouteImport } from './routes/account.profile'
import { Route as AccountQuotesRouteImport } from './routes/account.quotes'
import { Route as AccountWishlistRouteImport } from './routes/account.wishlist'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as EventsSlugRouteImport } from './routes/events.$slug'
import { Route as ProductsIndexRouteImport } from './routes/products.index'
import { Route as ShopIndexRouteImport } from './routes/shop.index'
import { Route as ShopSlugRouteImport } from './routes/shop.$slug'
import { Route as ShopCheckoutRouteImport } from './routes/shop.checkout'
import { Route as ShopOrderConfirmedRouteImport } from './routes/shop.order-confirmed'
import { Route as BlogCategoryIndexRouteImport } from './routes/blog.$category.index'
import { Route as BlogCategorySlugRouteImport } from './routes/blog.$category.$slug'
import { Route as ProductsCategoryIndexRouteImport } from './routes/products.$category.index'
import { Route as ProductsCategorySlugRouteImport } from './routes/products.$category.$slug'
import { Route as ShopCategorySlugRouteImport } from './routes/shop.category.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AquariumsAndHobbyistsRoute = AquariumsAndHobbyistsRouteImport.update({
            id: '/aquariums-and-hobbyists',path: '/aquariums-and-hobbyists',getParentRoute: () => rootRouteImport
          })
const ArtemiaCystsIncubationGuideRoute = ArtemiaCystsIncubationGuideRouteImport.update({
            id: '/artemia-cysts-incubation-guide',path: '/artemia-cysts-incubation-guide',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const ContactusRoute = ContactusRouteImport.update({
            id: '/contactus',path: '/contactus',getParentRoute: () => rootRouteImport
          })
const DecapsulatedArtemiaGuideRoute = DecapsulatedArtemiaGuideRouteImport.update({
            id: '/decapsulated-artemia-guide',path: '/decapsulated-artemia-guide',getParentRoute: () => rootRouteImport
          })
const DistanceSalesAgreementRoute = DistanceSalesAgreementRouteImport.update({
            id: '/distance-sales-agreement',path: '/distance-sales-agreement',getParentRoute: () => rootRouteImport
          })
const FaqsRoute = FaqsRouteImport.update({
            id: '/faqs',path: '/faqs',getParentRoute: () => rootRouteImport
          })
const GlossaryRoute = GlossaryRouteImport.update({
            id: '/glossary',path: '/glossary',getParentRoute: () => rootRouteImport
          })
const HorecaSeafoodMiddleEastRoute = HorecaSeafoodMiddleEastRouteImport.update({
            id: '/horeca-seafood-middle-east',path: '/horeca-seafood-middle-east',getParentRoute: () => rootRouteImport
          })
const KvkkDisclosureTextRoute = KvkkDisclosureTextRouteImport.update({
            id: '/kvkk-disclosure-text',path: '/kvkk-disclosure-text',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const OliveFlounderExportRoute = OliveFlounderExportRouteImport.update({
            id: '/olive-flounder-export',path: '/olive-flounder-export',getParentRoute: () => rootRouteImport
          })
const PanelRoute = PanelRouteImport.update({
            id: '/panel',path: '/panel',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProjectsRoute = ProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => rootRouteImport
          })
const RegionalTradeMiddleEastEuropeRoute = RegionalTradeMiddleEastEuropeRouteImport.update({
            id: '/regional-trade-middle-east-europe',path: '/regional-trade-middle-east-europe',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const RequestQuoteRoute = RequestQuoteRouteImport.update({
            id: '/request-quote',path: '/request-quote',getParentRoute: () => rootRouteImport
          })
const SalmonidOvaSolutionsRoute = SalmonidOvaSolutionsRouteImport.update({
            id: '/salmonid-ova-solutions',path: '/salmonid-ova-solutions',getParentRoute: () => rootRouteImport
          })
const SeafoodExportRoute = SeafoodExportRouteImport.update({
            id: '/seafood-export',path: '/seafood-export',getParentRoute: () => rootRouteImport
          })
const SeafoodExportFromTurkeyToEuropeRoute = SeafoodExportFromTurkeyToEuropeRouteImport.update({
            id: '/seafood-export-from-turkey-to-europe',path: '/seafood-export-from-turkey-to-europe',getParentRoute: () => rootRouteImport
          })
const ServicesSolutionsRoute = ServicesSolutionsRouteImport.update({
            id: '/services-solutions',path: '/services-solutions',getParentRoute: () => rootRouteImport
          })
const StandRoute = StandRouteImport.update({
            id: '/stand',path: '/stand',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AccountIndexRoute = AccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AccountRoute
          })
const AccountAddressesRoute = AccountAddressesRouteImport.update({
            id: '/addresses',path: '/addresses',getParentRoute: () => AccountRoute
          })
const AccountCustomsRoute = AccountCustomsRouteImport.update({
            id: '/customs',path: '/customs',getParentRoute: () => AccountRoute
          })
const AccountOrdersRoute = AccountOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AccountRoute
          })
const AccountProfileRoute = AccountProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AccountRoute
          })
const AccountQuotesRoute = AccountQuotesRouteImport.update({
            id: '/quotes',path: '/quotes',getParentRoute: () => AccountRoute
          })
const AccountWishlistRoute = AccountWishlistRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => AccountRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const EventsSlugRoute = EventsSlugRouteImport.update({
            id: '/events/$slug',path: '/events/$slug',getParentRoute: () => rootRouteImport
          })
const ProductsIndexRoute = ProductsIndexRouteImport.update({
            id: '/products/',path: '/products/',getParentRoute: () => rootRouteImport
          })
const ShopIndexRoute = ShopIndexRouteImport.update({
            id: '/shop/',path: '/shop/',getParentRoute: () => rootRouteImport
          })
const ShopSlugRoute = ShopSlugRouteImport.update({
            id: '/shop/$slug',path: '/shop/$slug',getParentRoute: () => rootRouteImport
          })
const ShopCheckoutRoute = ShopCheckoutRouteImport.update({
            id: '/shop/checkout',path: '/shop/checkout',getParentRoute: () => rootRouteImport
          })
const ShopOrderConfirmedRoute = ShopOrderConfirmedRouteImport.update({
            id: '/shop/order-confirmed',path: '/shop/order-confirmed',getParentRoute: () => rootRouteImport
          })
const BlogCategoryIndexRoute = BlogCategoryIndexRouteImport.update({
            id: '/blog/$category/',path: '/blog/$category/',getParentRoute: () => rootRouteImport
          })
const BlogCategorySlugRoute = BlogCategorySlugRouteImport.update({
            id: '/blog/$category/$slug',path: '/blog/$category/$slug',getParentRoute: () => rootRouteImport
          })
const ProductsCategoryIndexRoute = ProductsCategoryIndexRouteImport.update({
            id: '/products/$category/',path: '/products/$category/',getParentRoute: () => rootRouteImport
          })
const ProductsCategorySlugRoute = ProductsCategorySlugRouteImport.update({
            id: '/products/$category/$slug',path: '/products/$category/$slug',getParentRoute: () => rootRouteImport
          })
const ShopCategorySlugRoute = ShopCategorySlugRouteImport.update({
            id: '/shop/category/$slug',path: '/shop/category/$slug',getParentRoute: () => rootRouteImport
          })





const AccountRouteChildren = {
  AccountAddressesRoute: AccountAddressesRoute,AccountCustomsRoute: AccountCustomsRoute,AccountOrdersRoute: AccountOrdersRoute,AccountProfileRoute: AccountProfileRoute,AccountQuotesRoute: AccountQuotesRoute,AccountWishlistRoute: AccountWishlistRoute,AccountIndexRoute: AccountIndexRoute
}

const AccountRouteWithChildren = AccountRoute._addFileChildren(AccountRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutUsRoute: AboutUsRoute,AccountRoute: AccountRouteWithChildren,AquariumsAndHobbyistsRoute: AquariumsAndHobbyistsRoute,ArtemiaCystsIncubationGuideRoute: ArtemiaCystsIncubationGuideRoute,CartRoute: CartRoute,ContactusRoute: ContactusRoute,DecapsulatedArtemiaGuideRoute: DecapsulatedArtemiaGuideRoute,DistanceSalesAgreementRoute: DistanceSalesAgreementRoute,FaqsRoute: FaqsRoute,GlossaryRoute: GlossaryRoute,HorecaSeafoodMiddleEastRoute: HorecaSeafoodMiddleEastRoute,KvkkDisclosureTextRoute: KvkkDisclosureTextRoute,LoginRoute: LoginRoute,OliveFlounderExportRoute: OliveFlounderExportRoute,PanelRoute: PanelRoute,PrivacyRoute: PrivacyRoute,ProjectsRoute: ProjectsRoute,RegionalTradeMiddleEastEuropeRoute: RegionalTradeMiddleEastEuropeRoute,RegisterRoute: RegisterRoute,RequestQuoteRoute: RequestQuoteRoute,SalmonidOvaSolutionsRoute: SalmonidOvaSolutionsRoute,SeafoodExportRoute: SeafoodExportRoute,SeafoodExportFromTurkeyToEuropeRoute: SeafoodExportFromTurkeyToEuropeRoute,ServicesSolutionsRoute: ServicesSolutionsRoute,StandRoute: StandRoute,TermsRoute: TermsRoute,EventsSlugRoute: EventsSlugRoute,ShopSlugRoute: ShopSlugRoute,ShopCheckoutRoute: ShopCheckoutRoute,ShopOrderConfirmedRoute: ShopOrderConfirmedRoute,BlogIndexRoute: BlogIndexRoute,ProductsIndexRoute: ProductsIndexRoute,ShopIndexRoute: ShopIndexRoute,BlogCategorySlugRoute: BlogCategorySlugRoute,ProductsCategorySlugRoute: ProductsCategorySlugRoute,ShopCategorySlugRoute: ShopCategorySlugRoute,BlogCategoryIndexRoute: BlogCategoryIndexRoute,ProductsCategoryIndexRoute: ProductsCategoryIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)